import { render } from "./ReportCard.vue?vue&type=template&id=f8a9f9a8"
import script from "./ReportCard.vue?vue&type=script&lang=js"
export * from "./ReportCard.vue?vue&type=script&lang=js"

import "./ReportCard.vue?vue&type=style&index=0&id=f8a9f9a8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__